import { isUsMarketOpen, plusBusinessDay } from "@goodfill/business-days";
import { TimeInForce } from "@goodfill/domain-properties";
import { DateTime } from "luxon";
import { TIMEZONE_NEY_YORK } from "../../../../locale/timezone";

// It has to be 16:59, because 17:00 is already outside of the business hours
const defaultExpirationHour = 16;
const defaultExpirationMinute = 59;

export function createExpirationDate(timezone: string, currentTime: DateTime, timeInForce: TimeInForce) {
  const now = currentTime.setZone(timezone); // Must respect timezone of the bond to correctly set hours and minutes

  const expiration = now.set({
    hour: defaultExpirationHour,
    minute: defaultExpirationMinute,
    second: 0,
    millisecond: 0,
  });

  if (!isUsMarketOpen(now) && (timeInForce === TimeInForce.CustomToday || timeInForce === TimeInForce.CustomFuture)) {
    return plusBusinessDay(expiration.plus({ days: 1 }), TIMEZONE_NEY_YORK, 0);
  }

  return expiration;
}
